import { STATUS_FIELD } from "modules/swiftboard/components/advance-filter";
import { CHANNEL_LABEL } from "./channel.constants";

// Advanced filter of the Channel list. Every key must also be in FILTER_FIELDS of the backend's
// reminder_setup/channel/controller.js, the whitelist get-all filters on.
export const channelFilterFields = [
  {
    key: "channel_key",
    label: "Channel",
    type: "enum",
    group: "Details",
    options: Object.entries(CHANNEL_LABEL).map(([value, label]) => ({ value, label })),
  },
  { key: "supports_digest", label: "Digest", type: "boolean", group: "Details" },
  { key: "supports_html", label: "HTML content", type: "boolean", group: "Details" },
  { ...STATUS_FIELD, group: "Details" },
  { key: "created_date", label: "Created", type: "datetime", group: "Dates" },
];
